module.exports = __webpack_public_path__ + "static/media/icon-bonus.4becadfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RewardIcon/icon-bonus.svg
// module id = 1433
// module chunks = 1